const format = Intl.DateTimeFormat(undefined, {}).format;

export function DateCell({ getValue }) {
    const value = getValue();
    return value ? format(new Date(value)) : null;
}
